import { atom, selector } from "recoil";

import { OrderModel } from "graphql/generated";

import keys from "./constants";

export const plansState = atom({
  key: keys.PLANS_STATE,
  default: null
});

export const evalIdPlansState = selector({
  key: keys.EVALUATION_ID_PLANS_STATE,
  get: ({ get }) => {
    const planListState = get(plansState);
    if (!planListState) return [];

    return planListState.map((item) => item.evaluationId).filter((item) => item !== null);
  }
});

export const exportOrdersState = atom<OrderModel[]>({
  key: keys.EXPORT_ORDERS_STATE,
  default: []
});

export const orderState = atom({
  key: keys.ORDER_STATE,
  default: null
});
